
















import { Component, Vue, Watch } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import RestaurantList from "@/components/RestaurantList.vue";
import CTooltip from "@/components/CTooltip.vue";
import { RestaurantsApi } from "@/services/api-service";
import { SortDirection } from "@/api/api";
import RestaurantModule from "@/store/restaurant";
import PaginationModule from "@/store/pagination";
import OrderModule from "@/store/order";

@Component({
  components: {
    CHeader,
    RestaurantList,
    CFooter,
    CTooltip,
  },
})
export default class Restaurants extends Vue {
  private mounted() {
    this.getRestaurants();
    OrderModule.commitIsAddedCart(false);
  }

  private get pageNum() {
    return Number(this.$route.params.pageNum);
  }

  private get isAddedCart() {
    return OrderModule.isAddedCart;
  }

  @Watch("$route", { deep: true })
  private async getRestaurants() {
    const { query } = this.$route;
    const pageNum = this.$route.params?.pageNum ? Number(this.$route.params.pageNum) : 0;
    const limit = 4;

    try {
      const restaurantsRes = await RestaurantsApi.instance.getRestaurants(
        limit,
        pageNum === 0 ? 0 : (pageNum - 1) * limit,
        SortDirection.Desc,
        "createdAt",
        undefined,
        query?.genre ? String(query.genre) : undefined,
        query?.area ? String(query.area) : undefined,
        // eslint-disable-next-line prettier/prettier
        "takeoutable" in query && query.takeoutable === "true" ? true : undefined,
        // eslint-disable-next-line prettier/prettier
        "deliverable" in query && query.deliverable === "true" ? true : undefined,
        query?.q ? String(query.q) : undefined,
        true
      );
      RestaurantModule.commitRestaurants(restaurantsRes.data.data.items);
      PaginationModule.commitTotal(restaurantsRes.data.data.total);
      PaginationModule.commitLimit(limit);
    } catch (err) {
      console.log(err);
    }
  }
}
